import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  SimpleChanges,
  ViewEncapsulation,
  inject,
} from '@angular/core';
import { fuseAnimations } from '@fuse/animations';
import { FuseNavigationService } from '@fuse/components/navigation/navigation.service';
import { FuseNavigationItem } from '@fuse/components/navigation/navigation.types';
import { FuseUtilsService } from '@fuse/services/utils/utils.service';
import { ReplaySubject, Subject } from 'rxjs';
import { FuseHorizontalNavigationBasicItemComponent } from '@fuse/components/navigation/horizontal/components/basic/basic.component';
import { FuseHorizontalNavigationSpacerItemComponent } from '@fuse/components/navigation/horizontal/components/spacer/spacer.component';
import { MegaModuleMenuBranchComponent } from './mega-module-menu-branch.component';

/**
 * Same as Fuse horizontal navigation but top-level branch items use a full-width mega menu
 * instead of Material mat-menu.
 */
@Component({
  selector: 'app-mega-horizontal-navigation',
  templateUrl: './mega-horizontal-navigation.component.html',
  styleUrls: ['./mega-horizontal-navigation.component.scss'],
  animations: fuseAnimations,
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  exportAs: 'appMegaHorizontalNavigation',
  imports: [
    FuseHorizontalNavigationBasicItemComponent,
    MegaModuleMenuBranchComponent,
    FuseHorizontalNavigationSpacerItemComponent,
  ],
})
export class MegaHorizontalNavigationComponent implements OnChanges, OnInit, OnDestroy {
  private readonly _changeDetectorRef = inject(ChangeDetectorRef);
  private readonly _fuseNavigationService = inject(FuseNavigationService);
  private readonly _fuseUtilsService = inject(FuseUtilsService);

  @Input() name: string = this._fuseUtilsService.randomId();
  @Input() navigation: FuseNavigationItem[];

  onRefreshed: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);
  private readonly _unsubscribeAll = new Subject<void>();

  ngOnChanges(changes: SimpleChanges): void {
    if ('navigation' in changes) {
      this._changeDetectorRef.markForCheck();
    }
  }

  ngOnInit(): void {
    if (this.name === '') {
      this.name = this._fuseUtilsService.randomId();
    }
    this._fuseNavigationService.registerComponent(this.name, this as never);
  }

  ngOnDestroy(): void {
    this._fuseNavigationService.deregisterComponent(this.name);
    this._unsubscribeAll.next();
    this._unsubscribeAll.complete();
  }

  refresh(): void {
    this._changeDetectorRef.markForCheck();
    this.onRefreshed.next(true);
  }

  trackByFn(index: number, item: FuseNavigationItem): string {
    return item.id || String(index);
  }
}
